import { Action } from 'redux';
import { SetNavLocation } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface SetNavLocationAction extends Action {
  routerStateName: string;
  routerStateParams: any;
}

export function setNavLocation(routerStateName: string, routerStateParams: any): SetNavLocationAction {
  return {
    type: SetNavLocation,
    routerStateName,
    routerStateParams
  };
}

export const isSetNavLocationAction = isActionFactory<SetNavLocationAction>(SetNavLocation);
